import React from "react";
import { motion } from "framer-motion";
import { fadeInUp, viewportOnce } from "../motionVariants";

// Sourced from Shashank's resume — factual, not fabricated.
export default function About() {
    return (
        <section id="aboutRoot">
            <div className="sectionHead">
                <span className="eyebrow">About</span>
                <h2 className="sectionTitle">What I build</h2>
            </div>
            <motion.div
                id="aboutContent"
                variants={fadeInUp}
                initial="hidden"
                whileInView="visible"
                viewport={viewportOnce}
            >
                <p className="aboutParagraph">
                    I'm a Full-Stack Software Engineer at ENTNT, where I build production web applications and,
                    increasingly, agentic AI systems — multi-agent orchestration with LangGraph, retrieval
                    pipelines, and custom MCP servers.
                </p>
                <p className="aboutParagraph">
                    I enjoy problems where the AI has to actually hold up in production, not just in a demo.
                    Most recently that's meant building Maestro, a multi-agent research-and-writing system with
                    retrieval, evaluation, and deployment built in.
                </p>
            </motion.div>
        </section>
    );
}
